import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';

const LogOut = ({ userData: { displayName, email }, handleLogout }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1,
                py: '12px',
                px: '20px',
                borderTop: '1px solid #0000001F',
                background: '#FFF'
            }}
        >
            <Typography
                component="span"
                noWrap
                title={displayName || email}
                sx={{
                    minWidth: 0,
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '21px',
                    color: '#212121',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
            >
                Hi, {displayName || email}
            </Typography>
            <Button
                disableElevation
                variant="outlined"
                size="small"
                startIcon={<LogoutIcon sx={{ fontSize: 16 }} />}
                onClick={handleLogout}
                sx={{
                    flexShrink: 0,
                    fontSize: '13px',
                    fontWeight: 600,
                    lineHeight: '18px',
                    textTransform: 'none',
                    borderRadius: '999px',
                    px: 1.5,
                    py: '5px',
                    color: theme.palette.orange.default,
                    borderColor: theme.palette.orange.default,
                    '&:hover': {
                        borderColor: theme.palette.orange.dark,
                        color: theme.palette.orange.dark,
                        background: 'rgba(255, 120, 35, 0.08)'
                    },
                    '&:focus': {
                        outline: 'none'
                    }
                }}
            >
                Logout
            </Button>
        </Box>
    );
};

export default LogOut;
